import React from "react";
import { Leaf, Users, Coffee, Sparkles } from "lucide-react";

const values = [
  { icon: Leaf, t: "Inspirant", d: "Lumière naturelle, plantes, matériaux nobles — un cadre qui élève vos journées." },
  { icon: Users, t: "Convivial", d: "Un lieu chaleureux où indépendants et équipes peuvent travailler dans une ambiance sereine et professionnelle." },
  { icon: Coffee, t: "Hospitalier", d: "Du café, et un accueil chaleureux à votre arrivée." },
  { icon: Sparkles, t: "Premium", d: "Mobilier ergonomique, internet ultra-rapide, salles équipées dernier cri." },
];

export default function About() {
  return (
    <div className="container-x py-16" data-testid="about-page">
      <p className="overline text-[#2B8B8E]">À propos</p>
      <h1 className="text-4xl sm:text-5xl font-light mt-2 mb-6 max-w-3xl">L'espace de travail réimaginé pour les indépendants exigeants.</h1>
      <p className="text-lg text-muted-foreground max-w-3xl mb-12 leading-relaxed">
        Implanté au cœur de Vauvert, dans le Gard, Synergie Workspace est né d'une conviction simple : un environnement chaleureux et bien pensé change radicalement la qualité du travail. Notre devise : <em className="text-[#2B8B8E] font-medium">ici naissent les plus belles synergies</em>.
      </p>

      <img src="https://customer-assets-gfyr7b9c.emergentagent.net/job_horizon-book-1/artifacts/vihkdp9y_IMG-20260908-WA0006.jpg" alt="Synergie Workspace Vauvert" className="w-full h-[420px] object-cover rounded-3xl mb-16" />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {values.map((v) => (
          <div key={v.t} className="border border-border rounded-2xl p-7 bg-card" data-testid={`value-${v.t.toLowerCase()}`}>
            <v.icon size={28} className="text-[#2B8B8E] mb-4" />
            <h3 className="text-xl font-semibold mb-2">{v.t}</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">{v.d}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
